import React from 'react';
import Hero from './hero';
import Listproduct from './listproduct';

const Index = () => {
    return (
        <div className='product'>
            <Hero/>
            <Listproduct/>
        </div>
    );
}

export default Index;
